import {commentCategoriesDataLoader} from '../../../util/dataLoader';
import {ICommentCategoriesAPIResponse} from './commentCategoriesSlice';


export function getCommentCategories(filters) {
  return new Promise<ICommentCategoriesAPIResponse>((resolve) => {
    commentCategoriesDataLoader.get(filters).then((res: ICommentCategoriesAPIResponse) => {
      resolve(res)
    })
  })
}